<div class="app--floating-chat">
  @if (floatingVisible) {
    <div
      class="app--floating-chat--desktop justify-content-center align-items-center"
      (click)="openChat()"
      (keyup.enter)="openChat()"
      tabindex="0">
      <app-cigna-icon icon="chat" class="white size-32"></app-cigna-icon>
      <div class="xs-bold">{{ 'chat.chat' | translate }}</div>
    </div>
    <button pButton class="app--floating-chat--mobile" (click)="openChat()">
      <span aria-hidden="true" [ngClass]="{ 'sr-only': !!isMobile }">chat</span>
      <app-cigna-icon icon="chat"></app-cigna-icon>
    </button>
  }
</div>
